export const VALIDATE_APP_TOKEN_REQUEST = 'VALIDATE_APP_TOKEN_REQUEST';
export const VALIDATE_APP_TOKEN_SUCCESS = 'VALIDATE_APP_TOKEN_SUCCESS';
export const VALIDATE_APP_TOKEN_FAILURE = 'VALIDATE_APP_TOKEN_FAILURE';
export const RESET_APP_TOKEN            = 'RESET_APP_TOKEN';
